/* VYROXE Support Widget — instant answers from the live store FAQ.
 * No AI API, no backend, no cost. All answers are grounded in vyroxe.com's
 * actual policies. Structured so the matcher can be node-tested:
 * the FAQ data + scoreAnswer() run without a DOM. */
(function () {
'use strict';

/* ---------------- Knowledge base (mirrors vyroxe-ai-support-faq.md) ---------------- */
var FAQ = [
  { k: ['delivery guarantee', 'guaranteed delivery', '21-day delivery', '21 day delivery', 'delivery', 'delivery time', 'delivery take', 'shipping take', 'arrive', 'arrives'],
    a: 'Every VYROXE order is guaranteed to be delivered within 21 business days from the date of shipment. If your order has not arrived within that window, please email vyroxeofficial@gmail.com immediately.' },
  { k: ['processing time', 'how long to process', 'order processed', 'dispatch time', 'when will my order ship', 'when does my order ship', 'process my order'],
    a: 'Most orders are processed and prepared for shipment within 1-3 business days.' },
  { k: ['free shipping', 'shipping', 'shipping free', 'free delivery', 'shipping cost', 'shipping fee', 'delivery cost', 'delivery fee', 'how much is shipping', 'shipping charges'],
    a: 'Shipping is complimentary worldwide on all orders over $250. For orders under $250, the shipping cost is shown at checkout before you pay.' },
  { k: ['international shipping', 'ship internationally', 'worldwide shipping', 'do you ship to', 'ship to my country', 'countries you ship'],
    a: 'Yes — VYROXE ships worldwide. Priority is given to stock held in our international warehouses to keep delivery times short.' },
  { k: ['track my order', 'tracking number', 'where is my order', 'order status', 'track order', 'tracking', 'track my package'],
    a: 'Every order includes a tracking number so you can follow your package from our fulfillment center to your door. Your tracking details are sent by email once the order ships.' },
  { k: ['delayed', 'delivery delay', 'running late', 'not arrived', 'hasn\u2019t arrived', 'order late', 'late delivery', 'package late'],
    a: 'External factors such as extreme weather, carrier strikes, or customs processing can occasionally cause minor delays. If your order does not arrive within the guaranteed 21-day window, contact vyroxeofficial@gmail.com immediately.' },
  { k: ['customs', 'import duties', 'duty', 'import tax', 'customs charges'],
    a: 'Posted prices do not include taxes, shipping, handling, customs, or import charges unless expressly stated, so any customs or import duties are the customer\u2019s responsibility and vary by country.' },
  { k: ['return policy', 'returns policy', 'return', 'returns', 'how to return', 'start a return', 'send back', 'return an item', 'return window', 'send it back'],
    a: 'You have 14 days after receiving your item to request a return. Email vyroxeofficial@gmail.com to start — if accepted, we will send you a return shipping label with instructions. Items sent back without first requesting a return will not be accepted.' },
  { k: ['return condition', 'condition', 'unworn', 'with tags', 'eligible for return', 'return eligible'],
    a: 'To be eligible, the item must be unworn or unused, with tags attached. You will also need your receipt or proof of purchase.' },
  { k: ['damaged', 'defective', 'broken', 'wrong item', 'incorrect item', 'received the wrong'],
    a: 'Please inspect your order on arrival and contact vyroxeofficial@gmail.com immediately if the item is defective, damaged, or wrong, so we can evaluate the issue and make it right.' },
  { k: ['sale item', 'final sale', 'gift card', 'non-returnable', 'cannot be returned', 'return sale'],
    a: 'Sale items and gift cards cannot be returned.' },
  { k: ['exchange', 'exchange for', 'swap for', 'different size', 'change size'],
    a: 'The fastest way to get the item you want is to return the item you have and, once the return is accepted, place a separate purchase for the new item.' },
  { k: ['eu return', 'europe return', 'cooling off', 'eu right'],
    a: 'If your merchandise is shipped into the European Union, you have the right to cancel or return your order within 14 days for any reason, without justification. The item must still be unworn or unused, with tags attached, and you will need proof of purchase.' },
  { k: ['refund', 'money back', 'when will i be refunded', 'refund timing', 'refund status', 'get my refund'],
    a: 'Once we receive and inspect your return, we will notify you whether the refund was approved. Approved refunds are issued automatically to your original payment method within 10 business days. If more than 15 business days have passed since approval, contact vyroxeofficial@gmail.com.' },
  { k: ['size chart', 'sizing', 'what size', 'size guide', 'measurements', 'how do sizes', 'size help', 'bigger size', 'smaller size', 'which size'],
    a: 'Every product page carries its own size chart in plain text in the description, with VYROXE, US, and UK sizes and garment measurements in inches and centimeters. Measure yourself and compare against the chart.' },
  { k: ['true to size', 'runs small', 'runs large', 'runs big', 'between sizes', 'fit note'],
    a: 'Fit varies by design — some pieces are cut relaxed for layering, others closer to the body. Each product page includes a fit note describing the intended silhouette, including what to do if you are between sizes. Follow it rather than assuming.' },
  { k: ['currency', 'charged in', 'usd', 'dollar', 'what currency', 'payment currency'],
    a: 'The store shows prices in your local currency at checkout through automatic conversion. All transactions are settled in USD.' },
  { k: ['cancel my order', 'cancel order', 'cancel', 'change my order', 'modify my order', 'amend order'],
    a: 'Placing an order is an offer to purchase; it is accepted once VYROXE confirms it. Please review your order carefully before submitting, because cancellation may not be possible after the order is accepted.' },
  { k: ['material', 'fabric', 'what is it made of', 'made from', 'composition', 'polyester'],
    a: 'Material composition varies by piece and is listed on each product page — for example, structured outerwear may use premium synthetic leather, evening pieces may use tulle, silk blends, or feather trims. Check the product description for the exact composition.' },
  { k: ['care instructions', 'how to wash', 'how do i wash', 'can i wash', 'washing', 'dry clean', 'care for', 'wash it'],
    a: 'Care instructions are listed on each product page. Delicate and structured pieces may require professional cleaning — follow the guidance given for your specific item.' },
  { k: ['reviews', 'customer reviews', 'ratings', 'what do customers say'],
    a: 'Verified customer reviews appear on product pages. After your order is fulfilled, you will receive an email invitation to review your purchase.' },
  { k: ['color', 'colour', 'looks different', 'different from the photo', 'like the photos', 'picture vs real', 'color match'],
    a: 'We make every effort to represent products accurately, but colors and appearance may differ slightly depending on your screen and device settings.' },
  { k: ['contact', 'phone number', 'email address', 'talk to human', 'customer service', 'support team', 'get in touch', 'speak to someone'],
    a: 'You can reach us at vyroxeofficial@gmail.com or +447462252636. VYROXE LTD is a UK-registered company (17209346), Office 18664, 182-184 High Street North, London E6 2JA.' },
  { k: ['new arrival', 'new arrivals', 'latest', 'newest', 'just dropped', 'new products', 'what is new'],
    a: 'Our newest pieces are in the New Arrivals section on the homepage — fresh drops land daily. I can also search for a specific product if you tell me what you are looking for.' },
  { k: ['limited drop', 'capsule', 'limited edition', 'exclusive drop'],
    a: 'Our Limited Drop capsule features exclusive weekly pieces — check The Capsule Drop section on the homepage. Each Friday brings a new limited-edition piece.' },
  { k: ['discount', 'promo code', 'coupon', 'sale', 'offer', 'deal', 'promotion'],
    a: 'Check the product pages for current sale prices — discounted items show both the sale price and the original price. Subscribe to our newsletter for 20% off your first order.' },
  { k: ['price range', 'how much do', 'price of', 'cost of', 'how expensive'],
    a: 'VYROXE pieces range from $100 to $650+. Tell me which product you are interested in and I can look it up for you.' }
];

var FALLBACK = 'I want to make sure you get the right answer — please email vyroxeofficial@gmail.com and our team will help you directly.';

function normalize(s) {
  return ' ' + String(s).toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
}

function scoreAnswer(question) {
  var q = normalize(question);
  var best = null, bestScore = 0;
  for (var i = 0; i < FAQ.length; i++) {
    var score = 0, longest = 0;
    for (var j = 0; j < FAQ[i].k.length; j++) {
      var kw = normalize(FAQ[i].k[j]).trim();
      if (kw && q.indexOf(kw) !== -1) {
        var w = kw.indexOf(' ') !== -1 ? kw.length * 2 : kw.length; /* phrases weigh more */
        score += w;
        if (kw.length > longest) longest = kw.length;
      }
    }
    if (longest >= 5) score += 4; /* one solid distinctive word is enough */
    if (score > bestScore) { bestScore = score; best = FAQ[i]; }
  }
  return bestScore >= 9 ? best.a : FALLBACK;
}

/* node test hook */
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { scoreAnswer: scoreAnswer, FALLBACK: FALLBACK, FAQ: FAQ };
  return;
}

/* ---------------- Product search (Shopify predictive search API) ---------------- */
var STOPWORDS = ['do','does','did','you','your','yours','have','has','had','a','an','the','is','are','was','were','be','been','i','me','my','we','our','it','its','for','of','in','on','at','to','with','about','tell','show','give','get','find','search','looking','want','need','any','some','there','here','please','can','could','would','should','will','shall','may','might','like','just','only','also','and','or','but','if','then','than','so','as','by','from','into','over','after','before','between','through','during','under','again','once','am','anymore'];
function extractKeywords(query) {
  var words = normalize(query).trim().split(/\s+/);
  var keywords = [];
  for (var i = 0; i < words.length; i++) {
    var w = words[i];
    if (w.length >= 3 && STOPWORDS.indexOf(w) === -1) keywords.push(w);
  }
  return keywords.join(' ');
}
function searchProducts(query, callback) {
  var keywords = extractKeywords(query);
  if (!keywords) { callback([]); return; }
  var url = '/search/suggest.json?q=' + encodeURIComponent(keywords) + '&resources[type]=product&resources[limit]=8';
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.timeout = 8000;
  xhr.onload = function () {
    try {
      var data = JSON.parse(xhr.responseText);
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      callback(products);
    } catch (e) { callback([]); }
  };
  xhr.onerror = function () { callback([]); };
  xhr.ontimeout = function () { callback([]); };
  xhr.send();
}

var PRODUCT_CATEGORIES = ['watch','watches','jacket','jackets','coat','coats','blazer','dress','dresses','gown','shirt','shirts','trouser','trousers','pant','pants','jean','jeans','sweater','hoodie','tee','t-shirt','bag','bags','handbag','shoe','shoes','sneaker','sneakers','boot','boots','loafer','loafers','heel','heels','sandal','sandals','belt','belts','sunglass','sunglasses','wallet','scarf','tie','hat','cap','skirt','blouse','cardigan','vest','suit','suits','overcoat','trench','leather','silk','wool','cashmere','denim','faux fur','accessories','footwear','mens','ladies','womens','unisex'];
var POLICY_TOPICS = ['shipping','delivery','return','refund','exchange','track','tracking','cancel','cancellation','payment','discount','coupon','promo','sale','size','sizing','fit','material','fabric','wash','care','warranty','guarantee','contact','email','phone','address','hours','policy','policies','terms','privacy'];
function detectIntent(q) {
  var nq = normalize(q);
  // Check for product category mentions
  for (var i = 0; i < PRODUCT_CATEGORIES.length; i++) {
    if (nq.indexOf(' ' + PRODUCT_CATEGORIES[i] + ' ') !== -1 || nq.indexOf(' ' + PRODUCT_CATEGORIES[i] + 's ') !== -1) {
      return 'product';
    }
  }
  // Check for product intent phrases
  var productTriggers = ['do you have', 'do you sell', 'price of', 'how much is', 'tell me about', 'show me', 'looking for', 'search for', 'find me', 'buy a', 'buy an', 'purchase', 'in stock', 'available'];
  for (var j = 0; j < productTriggers.length; j++) {
    if (nq.indexOf(productTriggers[j]) !== -1) return 'product';
  }
  // Check for policy topics
  for (var k = 0; k < POLICY_TOPICS.length; k++) {
    if (nq.indexOf(' ' + POLICY_TOPICS[k]) !== -1) return 'policy';
  }
  return 'unknown';
}

/* ---------------- Widget UI ---------------- */
if (typeof window === 'undefined' || typeof document === 'undefined') return;
if (document.getElementById('vx-sup-root')) return; /* never double-mount */

var CSS = [
  '#vx-sup-root{position:fixed;z-index:2147483000;font-family:inherit;}',
  '#vx-sup-btn{position:fixed;right:20px;bottom:20px;width:58px;height:58px;border-radius:50%;background:#0a0a0a;border:1px solid #ffffff;color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 24px rgba(0,0,0,.35);padding:0;transition:transform .25s ease;}',
  '#vx-sup-btn svg{width:26px;height:26px;fill:none;stroke:#fff;stroke-width:1.8;}',
  '#vx-sup-btn:hover{transform:scale(1.05);}',
  '#vx-sup-panel{position:fixed;right:20px;bottom:90px;width:372px;max-width:calc(100vw - 40px);height:520px;max-height:calc(100vh - 130px);background:#fff;border:1px solid #e5e5e5;border-radius:14px;box-shadow:0 18px 60px rgba(0,0,0,.28);display:none;flex-direction:column;overflow:hidden;}',
  '#vx-sup-panel.vx-open{display:flex;}',
  '#vx-sup-head{background:#0a0a0a;color:#fff;padding:14px 16px;display:flex;align-items:center;justify-content:space-between;}',
  '#vx-sup-head .vx-title{font-size:13px;letter-spacing:.22em;font-weight:600;}',
  '#vx-sup-head .vx-sub{font-size:11px;color:#ffffff;letter-spacing:.08em;margin-top:2px;}',
  '#vx-sup-close{background:none;border:0;color:#fff;font-size:20px;cursor:pointer;line-height:1;padding:4px;}',
  '#vx-sup-msgs{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;background:#fafafa;}',
  '.vx-msg{max-width:82%;padding:10px 13px;border-radius:12px;font-size:13.5px;line-height:1.5;}',
  '.vx-bot{background:#111;color:#f5f5f5;align-self:flex-start;border-bottom-left-radius:3px;}',
  '.vx-user{background:#e9e9e9;color:#111;align-self:flex-end;border-bottom-right-radius:3px;}',
  '#vx-sup-chips{display:flex;gap:8px;flex-wrap:wrap;padding:10px 14px 0;background:#fafafa;}',
  '.vx-chip{border:1px solid #0a0a0a;background:#fff;color:#0a0a0a;font-size:12px;padding:6px 12px;border-radius:20px;cursor:pointer;}',
  '.vx-chip:hover{background:#0a0a0a;color:#fff;}',
  '#vx-sup-form{display:flex;border-top:1px solid #e5e5e5;background:#fff;}',
  '#vx-sup-input{flex:1;border:0;padding:13px 14px;font-size:13.5px;outline:none;background:transparent;}',
  '#vx-sup-send{background:#0a0a0a;color:#fff;border:0;padding:0 18px;font-size:13px;letter-spacing:.06em;cursor:pointer;}',
  '#vx-sup-note{font-size:10.5px;color:#999;text-align:center;padding:6px;background:#fff;}',
  '@media (max-width:480px){#vx-sup-panel{right:12px;bottom:86px;}#vx-sup-btn{right:12px;bottom:16px;}}'
].join('\n');

function el(tag, cls, html) {
  var d = document.createElement(tag);
  if (cls) d.className = cls;
  if (html != null) d.innerHTML = html;
  return d;
}

function mount() {
  var st = document.createElement('style');
  st.textContent = CSS;
  document.head.appendChild(st);

  var root = el('div'); root.id = 'vx-sup-root';

  var btn = el('button'); btn.id = 'vx-sup-btn'; btn.setAttribute('aria-label', 'Chat with VYROXE support');
  btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M21 12a8 8 0 0 1-8 8H4l2.3-2.9A8 8 0 1 1 21 12z"/><circle cx="9" cy="12" r="1" fill="#fff" stroke="none"/><circle cx="13" cy="12" r="1" fill="#fff" stroke="none"/><circle cx="17" cy="12" r="1" fill="#fff" stroke="none"/></svg>';

  var panel = el('div'); panel.id = 'vx-sup-panel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', 'VYROXE support chat');
  panel.innerHTML =
    '<div id="vx-sup-head"><div><div class="vx-title">VYROXE</div><div class="vx-sub">SUPPORT ASSISTANT</div></div>' +
    '<button id="vx-sup-close" aria-label="Close chat">&times;</button></div>' +
    '<div id="vx-sup-msgs"></div>' +
    '<div id="vx-sup-chips"></div>' +
    '<form id="vx-sup-form"><input id="vx-sup-input" type="text" placeholder="Ask about shipping, returns, sizing\u2026" autocomplete="off" aria-label="Type your question">' +
    '<button id="vx-sup-send" type="submit">SEND</button></form>' +
    '<div id="vx-sup-note">VYROXE</div>';

  root.appendChild(btn); root.appendChild(panel);
  document.body.appendChild(root);

  var msgs = panel.querySelector('#vx-sup-msgs');
  var chips = panel.querySelector('#vx-sup-chips');
  var form = panel.querySelector('#vx-sup-form');
  var input = panel.querySelector('#vx-sup-input');
  var opened = false;

  function addMsg(text, who, isHtml) {
    var m = el('div', 'vx-msg ' + who);
    if (isHtml) { m.innerHTML = text; } else { m.textContent = text; }
    msgs.appendChild(m);
    msgs.scrollTop = msgs.scrollHeight;
  }
  function addProductCard(p) {
    var price = p.price ? Number(p.price).toFixed(2) : '';
    var compare = p.compare_at_price ? Number(p.compare_at_price).toFixed(2) : '';
    var priceHtml = compare && compare !== price
      ? '<span style="color:#ffffff;font-weight:600;">$' + price + '</span> <span style="text-decoration:line-through;opacity:.6;font-size:.9em;">$' + compare + '</span>'
      : '<span style="color:#ffffff;font-weight:600;">$' + price + '</span>';
    var img = p.featured_image ? '<img src="' + p.featured_image.url + '&width=200" alt="" style="width:60px;height:75px;object-fit:cover;border-radius:8px;flex-shrink:0;">' : '';
    var html = '<div style="display:flex;gap:10px;align-items:center;">' + img +
      '<div style="flex:1;min-width:0;"><div style="font-weight:600;font-size:13px;margin-bottom:4px;">' + p.title + '</div>' +
      '<div style="font-size:13px;margin-bottom:6px;">' + priceHtml + '</div>' +
      '<a href="' + p.url + '" style="display:inline-block;padding:6px 14px;background:#ffffff;color:#000;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:.1em;text-decoration:none;">VIEW</a></div></div>';
    addMsg(html, 'vx-bot', true);
  }
  function ask(q) {
    if (!q.trim()) return;
    var query = q.trim();
    addMsg(query, 'vx-user');
    input.value = '';
    // Try FAQ first
    var faqAnswer = scoreAnswer(query);
    if (faqAnswer !== FALLBACK) {
      setTimeout(function () { addMsg(faqAnswer, 'vx-bot'); }, 350);
      return;
    }
    // Detect intent: product search vs policy question
    var intent = detectIntent(query);
    if (intent === 'product') {
      addMsg('Let me check our catalog...', 'vx-bot');
      searchProducts(query, function (products) {
        // Remove the "checking" message
        var checking = msgs.querySelector('.vx-bot:last-child');
        if (checking && checking.textContent.indexOf('catalog') !== -1) checking.remove();
        if (products.length > 0) {
          addMsg('Here is what I found:', 'vx-bot');
          products.slice(0, 3).forEach(addProductCard);
        } else {
          addMsg('I could not find a matching product. Try our search at the top of the page, or email vyroxeofficial@gmail.com and our team will help.', 'vx-bot');
        }
      });
      return;
    }
    // Fallback
    setTimeout(function () { addMsg(FALLBACK, 'vx-bot'); }, 350);
  }
  ['Shipping', 'Returns', 'Sizing', 'Track my order', 'Contact us'].forEach(function (c) {
    var b = el('button', 'vx-chip', c);
    b.type = 'button';
    b.onclick = function () { ask(c); };
    chips.appendChild(b);
  });

  btn.onclick = function () {
    opened = !opened;
    panel.classList.toggle('vx-open', opened);
    if (opened && !msgs.children.length) {
      addMsg('Welcome to VYROXE. Ask me about shipping, returns, sizing, or your order — I answer instantly.', 'vx-bot');
      setTimeout(function () { input.focus(); }, 100);
    }
  };
  panel.querySelector('#vx-sup-close').onclick = function () { opened = false; panel.classList.remove('vx-open'); };
  form.onsubmit = function (e) { e.preventDefault(); ask(input.value); };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
})();
